import { Container } from './styles';
import ScrollAnimation from 'react-animate-on-scroll';
import bekhzod from '../../assets/bekhzod.png';
import { NavHashLink } from 'react-router-hash-link';
import linkedin from '../../assets/linkedin.svg';
import kaggle from '../../assets/kaggle.svg';
import githubIcon from '../../assets/github.svg';
import kakao from '../../assets/kakao.png';
import telegram from '../../assets/telegram.svg';
import instagramIcon from '../../assets/instagram.svg';
import { StunningIconWrapper } from '../Shared/StunningIconWrapper';

const images = [linkedin, githubIcon, kakao, kaggle, instagramIcon, telegram];
const imageAlts = ['LinkedIn', 'GitHub', 'KakaoTalk', 'Kaggle', 'Instagram', 'Telegram'];
const platformNames = ['linkedin', 'github', 'kakao', 'kaggle', 'instagram', 'telegram'];
const links = ["https://www.linkedin.com/in/bekhzod-olimov-phd-33059bb1/", 
			   "https://github.com/bekhzod-olimov",
			   "https://drive.google.com/file/d/14C7KpoTdY2aJBpx5LdKTKRu4R2e_PoSK/view?usp=sharing", 
			   "https://www.kaggle.com/killa92", 
			   "https://www.instagram.com/thevml_koreya/",
			   "https://t.me/bekhzodAI"];

export function Hero() {
	return (
		<Container id='home'>
			<div
				style={{
					flex: 1,
				}}
				className='hero-text'
			>
				<ScrollAnimation animateIn='fadeInUp'>
					<p>
						Hi, there <span className='wave-emoji' role='img' aria-label='Waving hand'>👋</span> I am
					</p>
				</ScrollAnimation>
				<ScrollAnimation animateIn='fadeInUp' delay={0.2 * 1000}>
					<h1>Bekhzod Olimov</h1>
				</ScrollAnimation>
				<ScrollAnimation animateIn='fadeInUp' delay={0.4 * 1000}>
					<h3>Principal AI Engineer & Researcher</h3>
				</ScrollAnimation>
				<ScrollAnimation animateIn='fadeInUp' delay={0.6 * 1000}>
					<p className='small-resume'>7+ years driving AI innovation | PhD in Computer Science | Transforming cutting-edge research into production-grade solutions</p>
				</ScrollAnimation>
				
				<ScrollAnimation animateIn='fadeInUp' delay={0.7 * 1000}>
					<div className='achievement-badges'>
						<a 
							href="https://drive.google.com/file/d/15M73Jd0uqk0OWkuUtlHunTUQ_N6g4oCF/view?usp=sharing" 
							target="_blank" 
							rel="noopener noreferrer" 
							className='badge'
							title="PhD in Computer Science & Engineering - GPA: 4.5/4.5 (Perfect) - Academic Transcripts"
						>
							<span className='badge-icon'>🎓</span>
							<span>PhD • GPA 4.5/4.5</span>
						</a>
						<a 
							href="https://scholar.google.com/citations?user=3QhMoi0AAAAJ&hl=en" 
							target="_blank" 
							rel="noopener noreferrer" 
							className='badge'
							title="12 SCIE Papers • 550+ Citations • h-index: 11"
						>
							<span className='badge-icon'>📊</span>
							<span>550+ Citations</span>
						</a>
						<a 
							href="https://drive.google.com/file/d/1rMVCXPLncBihuK0MS3csQPpYUbDjHuGu/view" 
							target="_blank" 
							rel="noopener noreferrer" 
							className='badge'
							title="English (TOEIC 985/990, IELTS 8.0) • Korean (TOPIK 6) • Uzbek/Russian (Native)"
						>
							<span className='badge-icon'>🌍</span>
							<span>4 Languages</span>
						</a>
						<a 
							href="https://www.kaggle.com/killa92" 
							target="_blank" 
							rel="noopener noreferrer" 
							className='badge'
							title="Kaggle Expert • 1st Place: Garbage Classification (98.7%, 470+ teams)"
						>
							<span className='badge-icon'>🏅</span>
							<span>Kaggle Expert</span>
						</a>
						<a 
							href="https://github.com/bekhzod-olimov" 
							target="_blank" 
							rel="noopener noreferrer" 
							className='badge'
							title="25+ Production AI Projects • GitHub Portfolio"
						>
							<span className='badge-icon'>🚀</span>
							<span>25+ Projects</span>
						</a>
					</div>
				</ScrollAnimation>
				
				<ScrollAnimation animateIn='fadeInUp' delay={0.9 * 1000}>
					<NavHashLink smooth to='#contact' className='button'>
						Contact Me
					</NavHashLink>
				</ScrollAnimation>
				<ScrollAnimation animateIn='fadeInUp' delay={1 * 1000}>
					
					<div
						style={{
							display: 'flex',
							flexWrap: 'wrap',
							gap: '10px',
							marginTop: '30px',
						}}
					>
						{images.map((item, index) => (
							<ScrollAnimation
								key={index}
								animateIn='fadeInLeft'
								delay={index * 0.1 * 1000}
							>
								<a href={links[index]} target="_blank" rel="noopener noreferrer">
									<StunningIconWrapper
										type="social"
										platform={platformNames[index]}
										delay={index}
									>
										<img
											style={{
											width: '100%',
											height: '100%',
											objectFit: 'contain',
											}}
											src={item}
											alt={imageAlts[index]}
										/>
									</StunningIconWrapper>
								</a>
							</ScrollAnimation>
						))}
					</div>
					
				</ScrollAnimation>
			</div>
			<div
				style={{
					flex: '1',
					display: 'flex',
					justifyContent: 'center',
				}}
				className='hero-image'
			>
				<ScrollAnimation animateIn='fadeInRight' delay={0.2 * 1000}>
					<img
						style={{
							borderRadius: '15px',
						}}
						src={bekhzod}
						alt='profile_pic'
					/>
				</ScrollAnimation>
			</div>
		</Container>
	);
}
